import i18n from '@/i18n'
import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas'
import { _ } from 'vue-underscore'

import Highcharts from 'highcharts'
function separadorMiles(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

function genericchart() {
  return {
    // title: { text: i18n.t('chartsData.market-evol') },
    credits: {
      enabled: false
    },
    tooltip: {
      shared: true
    },
    yAxis: [{
      min: 0,
      title: {
        text: null
      },
      labels: {
        // formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('marketplace.eur-sqm') : '') }
      }
    }],
    plotOptions: {
      series: {
        connectNulls: true
      }
    },
    series: []
  }
}

function generateStackTableOptions(chartinfo, allseries) {
  const res = {
    stocktableresidential: isresidentialtable(chartinfo) ? allseries.filter(item => { return item.name === 'stocktable' })[0].data : { residential: null },
    stocktableresidential_demand: isresidentialtable(chartinfo) ? allseries.filter(item => { return item.name === 'stockdemandtable' })[0].data : { residential: null },
    stocktablenoresidential: !isresidentialtable(chartinfo) ? allseries.filter(item => { return item.name === 'stocktable' })[0].data : null,
    stocktablenoresidential_demand: !isresidentialtable(chartinfo) ? allseries.filter(item => { return item.name === 'stockdemandtable' })[0].data : null,
    stocktablenoresidentialbuckets: ['< 500', '500 - 1.000', '1.000 - 2.500', '2.500 - 10.000', '> 10.000']
  }
  if (res.stocktablenoresidential !== null) { // se calculan los percents
    let totalpub = res.stocktablenoresidential.totalpub
    res.stocktablenoresidential.bucket1percent = (res.stocktablenoresidential.bucket1pub * 100) / totalpub
    res.stocktablenoresidential.bucket2percent = (res.stocktablenoresidential.bucket2pub * 100) / totalpub
    res.stocktablenoresidential.bucket3percent = (res.stocktablenoresidential.bucket3pub * 100) / totalpub
    res.stocktablenoresidential.bucket4percent = (res.stocktablenoresidential.bucket4pub * 100) / totalpub
    res.stocktablenoresidential.bucket5percent = (res.stocktablenoresidential.bucket5pub * 100) / totalpub
    res.stocktablenoresidential.totalpercent = 100

    totalpub = res.stocktablenoresidential_demand.totalpub
    res.stocktablenoresidential_demand.bucket1percent = (res.stocktablenoresidential_demand.bucket1pub * 100) / totalpub
    res.stocktablenoresidential_demand.bucket2percent = (res.stocktablenoresidential_demand.bucket2pub * 100) / totalpub
    res.stocktablenoresidential_demand.bucket3percent = (res.stocktablenoresidential_demand.bucket3pub * 100) / totalpub
    res.stocktablenoresidential_demand.bucket4percent = (res.stocktablenoresidential_demand.bucket4pub * 100) / totalpub
    res.stocktablenoresidential_demand.bucket5percent = (res.stocktablenoresidential_demand.bucket5pub * 100) / totalpub
    res.stocktablenoresidential_demand.totalpercent = 100
  } else {
    if (res.stocktableresidential.residential) {
      const totalpub = res.stocktableresidential.residential.totalpub
      res.stocktableresidential.residential.room1percent = (res.stocktableresidential.residential.room1pub * 100) / totalpub
      res.stocktableresidential.residential.room2percent = (res.stocktableresidential.residential.room2pub * 100) / totalpub
      res.stocktableresidential.residential.room3percent = (res.stocktableresidential.residential.room3pub * 100) / totalpub
      res.stocktableresidential.residential.room4percent = (res.stocktableresidential.residential.room4pub * 100) / totalpub
      res.stocktableresidential.residential.totalpercent = 100
    }
    if (res.stocktableresidential.house) {
      const totalpub = res.stocktableresidential.house.totalpub
      res.stocktableresidential.house.room1percent = (res.stocktableresidential.house.room1pub * 100) / totalpub
      res.stocktableresidential.house.room2percent = (res.stocktableresidential.house.room2pub * 100) / totalpub
      res.stocktableresidential.house.room3percent = (res.stocktableresidential.house.room3pub * 100) / totalpub
      res.stocktableresidential.house.room4percent = (res.stocktableresidential.house.room4pub * 100) / totalpub
      res.stocktableresidential.house.totalpercent = 100
    }
    if (res.stocktableresidential.flat) {
      const totalpub = res.stocktableresidential.flat.totalpub
      res.stocktableresidential.flat.room1percent = (res.stocktableresidential.flat.room1pub * 100) / totalpub
      res.stocktableresidential.flat.room2percent = (res.stocktableresidential.flat.room2pub * 100) / totalpub
      res.stocktableresidential.flat.room3percent = (res.stocktableresidential.flat.room3pub * 100) / totalpub
      res.stocktableresidential.flat.room4percent = (res.stocktableresidential.flat.room4pub * 100) / totalpub
      res.stocktableresidential.flat.totalpercent = 100
    }
    if (res.stocktableresidential_demand.residential) {
      const totalpub = res.stocktableresidential_demand.residential.totalpub
      res.stocktableresidential_demand.residential.room1percent = (res.stocktableresidential_demand.residential.room1pub * 100) / totalpub
      res.stocktableresidential_demand.residential.room2percent = (res.stocktableresidential_demand.residential.room2pub * 100) / totalpub
      res.stocktableresidential_demand.residential.room3percent = (res.stocktableresidential_demand.residential.room3pub * 100) / totalpub
      res.stocktableresidential_demand.residential.room4percent = (res.stocktableresidential_demand.residential.room4pub * 100) / totalpub
      res.stocktableresidential_demand.residential.totalpercent = 100
    }
    if (res.stocktableresidential_demand.house) {
      const totalpub = res.stocktableresidential_demand.house.totalpub
      res.stocktableresidential_demand.house.room1percent = (res.stocktableresidential_demand.house.room1pub * 100) / totalpub
      res.stocktableresidential_demand.house.room2percent = (res.stocktableresidential_demand.house.room2pub * 100) / totalpub
      res.stocktableresidential_demand.house.room3percent = (res.stocktableresidential_demand.house.room3pub * 100) / totalpub
      res.stocktableresidential_demand.house.room4percent = (res.stocktableresidential_demand.house.room4pub * 100) / totalpub
      res.stocktableresidential_demand.house.totalpercent = 100
    }
    if (res.stocktableresidential_demand.flat) {
      const totalpub = res.stocktableresidential_demand.flat.totalpub
      res.stocktableresidential_demand.flat.room1percent = (res.stocktableresidential_demand.flat.room1pub * 100) / totalpub
      res.stocktableresidential_demand.flat.room2percent = (res.stocktableresidential_demand.flat.room2pub * 100) / totalpub
      res.stocktableresidential_demand.flat.room3percent = (res.stocktableresidential_demand.flat.room3pub * 100) / totalpub
      res.stocktableresidential_demand.flat.room4percent = (res.stocktableresidential_demand.flat.room4pub * 100) / totalpub
      res.stocktableresidential_demand.flat.totalpercent = 100
    }
    // debugger
    // res.stocktableresidential.netFlat = allseries.filter(item => { return item.name === 'netyieldstock' })[0].data.filter(item => { return item.tipo === 1 })[0]
    // res.stocktableresidential.netHouse = allseries.filter(item => { return item.name === 'netyieldstock' })[0].data.filter(item => { return item.tipo === 2 })[0]
  }
  return res
}

function isresidentialtable(chartinfo) {
  return chartinfo.charttitle === 'residential' && chartinfo.charttype === 'stocktable'
}

function getobjectbylabel(serie, label) {
  const res = serie.filter(itemx => { return itemx.label === label })
  if (res.length > 0) {
    return res[0]
  } else {
    return null
  }
}

function generateHigchartOptions(chartinfo, allseries, locationname, country_name, geolevelselected) {
  let chart = genericchart()
  chart.title = { text: i18n.t(chartinfo.charttitle) }
  if (chartinfo.formatertyppe === 'separadorMiles') {
    chart.labels = {
      formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t(chartinfo.formaterlabel) : '') }
    }
  } else if (chartinfo.formatertyppe === 'percent') {
    chart.labels = {
      format: chartinfo.formaterlabel
    }
  } else if (chartinfo.formatertyppe === 'separadorMilesAllowNegative') {
    chart.yAxis.min = null
    if (chart.yAxis.length > 0) {
      chart.yAxis[0].min = null
    }
    chart.labels = {
      formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t(chartinfo.formaterlabel) : '') }
    }
  }
  if (chartinfo.charttype === 'stackcolumnrooms') {
    chart.chart = {
      type: 'column'
    }
    chart.xAxis = {
      stacked: true,
      type: 'category'
    }
    chart.yAxis = {
      min: 0,
      max: 100,
      stacked: true,
      labels: {
        format: '{value:,.0f} %'
      },
      title: {
        text: null
      }
    }
    chart.plotOptions = {
      column: {
        stacking: 'normal',
        borderWidth: 0
      }
    }
    chart.tooltip.pointFormat = chartinfo.formaterlabel
  }

  if (chartinfo.charttype === 'solidgauge' || chartinfo.charttype === 'solidgaugeclean') {
    chart.chart = {
      type: 'solidgauge'
    }
    chart.pane = {
      center: ['50%', '75%'],
      size: '130%',
      startAngle: -90,
      endAngle: 90,
      background: {
        backgroundColor: '#1e3cff',
        innerRadius: '60%',
        outerRadius: '100%',
        shape: 'arc',
        borderColor: 'none'
      }
    }
    chart.tooltip = {
      enabled: false
    }
    chart.yAxis = {
      lineWidth: 0,
      minorTickInterval: null,
      tickAmount: 2,
      fontFamily: 'Open Sans',
      min: 0,
      max: 100,
      labels: {
        y: 12,
        x: -3,
        formatter: function() {
          var data = {
            min: 979,
            minTransactions: 66,
            minLabel: 'Q1 19',
            max: 989,
            maxTransactions: 76,
            maxLabel: 'Q2 20'
          }
          if (this.isFirst) return `${separadorMiles(Math.round(data.min))} ${i18n.t('marketplace.eur-sqm')}<br/> (${separadorMiles(data.minTransactions > 0 ? separadorMiles(data.minTransactions) : '-')}) <br/>${data.minLabel}`
          else return `${separadorMiles(Math.round(data.max))} ${i18n.t('marketplace.eur-sqm')} <br/> (${data.maxTransactions > 0 ? separadorMiles(data.maxTransactions) : '-'}) <br/>${data.maxLabel}`
        },
        style: {
          fontSize: '0.8em',
          fontWeight: '800'
        }
      }
    }
    chart.plotOptions = {
      solidgauge: {
        dataLabels: {
          y: 5,
          borderWidth: 0,
          useHTML: true
        },
        colors: ['#28cf64 ']
      }
    }
  }

  if (chartinfo.charttype === 'area') {
    chart.chart = {
      type: 'area'
    }
    chart.legend = {
      enabled: false
    }
    chart.plotOptions = {
      area: {
        fillColor: {
          pattern: {
            path: {
              d: 'M 3 0 L 3 10 M 8 0 L 8 10',
              strokeWidth: 3
            },
            width: 10,
            height: 10,
            opacity: 0.4
          }
        },
        lineWidth: 0,
        tooltip:
        {
          headerFormat: '',
          pointFormatter: function() {
            return separadorMiles(this.x) + i18n.t('marketplace.eur-sqm') + ' <br>' + separadorMiles(Math.round(this.y)) + ' #'
          }
        }
      },
      series: { turboThreshold: 60000 }
    }
    chart.xAxis = [{
      title: {
        text: null
      },
      labels: {
        formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' ' + i18n.t('marketplace.eur-sqm') : '') }
      },
      alignTicks: false,
      tickInterval: 500, // 2 si es alquiler
      minRange: 10
    }]
    chart.yAxis = [{
      title: null,
      labels: {
        formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' #' : '') }
      },
      allowDecimals: false
    }]
  }

  if (chartinfo.charttype === 'supplydist') {
    chart.chart = {
      type: 'bar'
    }
    chart.legend = {
      enabled: true
    }
    chart.xAxis = {
      title: {
        text: ''
      },
      categories: [],
      labels: {
        formatter: function() { return this.value + (this.isFirst ? ' ' + i18n.t('marketplace.eur-sqm') : '') }
      },
      reversed: false
    }
    chart.yAxis = {
      title: {
        text: ''
      },
      labels: {
        format: '{value:,.0f}',
        formatter: function() { return `${Math.abs(this.value)} %` }
      }
    }
    chart.plotOptions = {
      series: {
        stacking: 'normal',
        borderWidth: 0,
        label: {
          connectorAllowed: false
        },
        pointWidth: 20
      }
    }
  }

  if (chartinfo.charttype === 'benchmark') {
    // chart = build_basicbar('askingpricetop25', 1, 'em2_Asking', response, country_name, geo_name, 'asking', geolevel)
    chart = {}
  }

  if (chartinfo.charttype === 'columnspercent') {
    // chart = build_basicbar('askingpricetop25', 1, 'em2_Asking', response, country_name, geo_name, 'asking', geolevel)
    chart.xAxis = [{
      labels: {
      }
    }]
    chart.yAxis = [
      {
        title: {
          text: null
        },
        labels: {
          formatter: function() { return separadorMiles(this.value) + ' ' + i18n.t('uts') + '' }
        }
      }]
    chart.tooltip = {
      pointFormat: '<b>{point.y} ' + i18n.t('uts') + ' </b> <br/> ' + i18n.t('chart_legend_modified_listings') + ' (% ' + i18n.t('total') + '): {point.percentage_pub_pricechanged}%',
      shared: true
    }
    chart.plotOptions = {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '<span style="font-size: 9px; font-weight: 400;">{point.percentage_pub_pricechanged}%</span>'
        }
      }
    }
  }

  let alllabels = []
  chartinfo.dataseries.forEach(dataserie => {
    let values = []
    alllabels = []
    try {
      if (dataserie.seriename !== 'calculated') {
        if (dataserie.groupname) {
          values = allseries.filter(item => { return item.name === dataserie.seriename })[0].data.filter(item => {
            return item.bucket === dataserie.groupname
          }).map((item) => {
            return {
              name: item.label,
              y: item[dataserie.propertyname]
            }
          })
        } else {
          if (dataserie.propertyname.indexOf('.') > 0) {
            // debugger
            const series = dataserie.propertyname.split('.')
            values = allseries.filter(item => { return item.name === dataserie.seriename })[0].data[series[0]].map((item) => {
              return {
                name: item.label,
                y: item[series[1]]
              }
            })
          } else {
            // console.log(chartinfo.charttitle)
            // debugger
            try {
              if (allseries.filter(item => { return item.name === dataserie.seriename }).length === 0) {
                // debugger
                values = []
              }
              values = allseries.filter(item => { return item.name === dataserie.seriename })[0].data.map((item) => {
                return {
                  name: item.label,
                  y: item[dataserie.propertyname]
                }
              })
            } catch (error) {
              console.log(error)
              // debugger
            }
          }
        }
        alllabels = alllabels.concat(values.map((item) => { return item.name }))
        values = values.filter(item => { return item.y !== null })
        if (dataserie.seriename === 'askingevolution') {
          values = values.filter(item => { return item.y !== 0 })
        }
      } else {
        if (dataserie.propertyname === 'gapcalcreverse' || dataserie.propertyname === 'gapcalc') {
          const serie1 = allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data.map((item) => {
            return {
              name: item.label,
              y: item[dataserie.calculatedseries[0].propertyname]
            }
          })
          const serie2 = allseries.filter(item => { return item.name === dataserie.calculatedseries[1].seriename })[0].data.map((item) => {
            return {
              name: item.label,
              y: item[dataserie.calculatedseries[1].propertyname]
            }
          })
          values = serie1.map((item) => {
            const res = serie2.filter(data => data.name === item.name)
            let reverse = 1
            if (dataserie.propertyname === 'gapcalcreverse') {
              reverse = -1
            }
            if (res.length === 1) {
              return {
                'name': item.name,
                'y': res[0].y === null ? null : (Math.round(((1 - res[0].y / item.y)) * 100)) * reverse
              }
            } else {
              return {
                'name': item.name,
                'y': null
              }
            }
          })
        } else if (dataserie.propertyname === 'stackcols') {
          values = allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data.map((item) => {
            return {
              'name': item.label,
              'Nombre': dataserie.calculatedseries[0].propertyname + i18n.t('maps.bed'),
              'valor': item[dataserie.calculatedseries[0].propertyname],
              'y': (item[dataserie.calculatedseries[0].propertyname] * 100) / ((item[dataserie.calculatedseries[3].propertyname] ?? 0) + (item[dataserie.calculatedseries[2].propertyname] ?? 0) + (item[dataserie.calculatedseries[1].propertyname] ?? 0) + (item[dataserie.calculatedseries[0].propertyname] ?? 0))
            }
          })
        } else if (dataserie.propertyname === 'stackbuckets') {
          values = allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data.map((item) => {
            return {
              'name': item.label,
              'Nombre': dataserie.name,
              'valor': item[dataserie.calculatedseries[0].propertyname],
              'y': (item[dataserie.calculatedseries[0].propertyname] * 100) / ((item[dataserie.calculatedseries[4].propertyname] ?? 0) + (item[dataserie.calculatedseries[3].propertyname] ?? 0) + (item[dataserie.calculatedseries[2].propertyname] ?? 0) + (item[dataserie.calculatedseries[1].propertyname] ?? 0) + (item[dataserie.calculatedseries[0].propertyname] ?? 0))
            }
          })
        } else if (dataserie.propertyname === 'stack2cols') {
          values = allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data.map((item) => {
            return {
              'name': item.label,
              'color': dataserie.color,
              'Nombre': dataserie.name,
              'y': item[dataserie.calculatedseries[0].propertyname]
            }
          })
        } else if (dataserie.propertyname === 'solidgaugecalc' || chartinfo.charttype === 'solidgaugeclean') {
          values = [allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data]
          if (values[0] === null) { values = [] }
        } else if (dataserie.propertyname === 'areacalc') {
          values = allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data.map((item) => {
            return [item.em2, item.pub]
          })
        } else if (dataserie.propertyname === 'supplydistcalc') {
          values = [allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data]
          if (values[0] === null) { values = [] }
        } else if (dataserie.propertyname === 'benchmarkcalc') {
          values = [allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data]
          if (values[0] === null) { values = [] }
        } else if (dataserie.propertyname === 'labelpercent') {
          values = allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data.map(item => {
            return {
              'name': item.label,
              'y': item[dataserie.calculatedseries[0].propertyname],
              'color': '#1e3cff',
              'percentage_pub_pricechanged': item[dataserie.calculatedseries[1].propertyname]
            }
          })
          alllabels = values.map(item => { return item.name })
        } else if (dataserie.propertyname === 'grossyield') {
          const series2 = allseries.filter(item => { return item.name === dataserie.calculatedseries[1].seriename })[0].data
          values = allseries.filter(item => { return item.name === dataserie.calculatedseries[0].seriename })[0].data.map(item => {
            const item2 = getobjectbylabel(series2, item.label)
            if (item2) {
              return {
                'name': item.label,
                'y': item[dataserie.calculatedseries[0].propertyname] != null ? ((item[dataserie.calculatedseries[0].propertyname] * 12) / item2[dataserie.calculatedseries[1].propertyname]) * 100 : 0
              }
            } else {
              return {
                'name': item.label,
                'y': null
              }
            }
          })
          alllabels = alllabels.concat(values.map((item) => { return item.name }))
        } else {
          // debugger
        }
      }
    } catch (erre1) {
      console.error(erre1)
      console.log(dataserie)
    }
    if (values.length > 0) {
      if (dataserie.yAxis !== 0 && chart.yAxis.length === 1) {
        chart.yAxis.push({
          min: 0,
          title: {
            text: null
          },
          labels: {
            formatter: function() { return separadorMiles(this.value) + (this.value === 0 ? ' uts' : '') }
          },
          opposite: true
        })
        if (dataserie.seriename === 'calculated' && (dataserie.propertyname === 'gapcalc' || dataserie.propertyname === 'gapcalcreverse')) {
          chart.yAxis[chart.yAxis.length - 1].max = 100
          if (Math.min.apply(null, values.map(item => { return item.y })) < 0) {
            chart.yAxis[chart.yAxis.length - 1].min = -100
          }
        }
      }
      if (chartinfo.charttype === 'stackcolumnrooms') {
        chart.series.push({
          index: chart.series.length + 1,
          legendIndex: dataserie.zIndex,
          data: values,
          name: i18n.t(dataserie.name),
          color: dataserie.color
        })
      } else if (chartinfo.charttype === 'solidgauge') {
        chart.title = { text: i18n.t(chartinfo.charttitle) + ' - ' + values[0][dataserie.calculatedseries[9].propertyname] }
        chart.yAxis.labels.formatter = function() {
          var data = {
            min: values[0][dataserie.calculatedseries[3].propertyname],
            minTransactions: values[0][dataserie.calculatedseries[4].propertyname],
            minLabel: values[0][dataserie.calculatedseries[5].propertyname],
            max: values[0][dataserie.calculatedseries[6].propertyname],
            maxTransactions: values[0][dataserie.calculatedseries[7].propertyname],
            maxLabel: values[0][dataserie.calculatedseries[8].propertyname]
          }
          if (this.isFirst) return `${separadorMiles(Math.round(data.min))} ${i18n.t(dataserie.name)}<br/> (${separadorMiles(data.minTransactions > 0 ? separadorMiles(data.minTransactions) : '-')}) <br/>${data.minLabel}`
          else return `${separadorMiles(Math.round(data.max))} ${i18n.t(dataserie.name)} <br/> (${data.maxTransactions > 0 ? separadorMiles(data.maxTransactions) : '-'}) <br/>${data.maxLabel}`
        }
        chart.series.push({
          name: i18n.t('chartsData.recovery'),
          data: [values[0][dataserie.calculatedseries[0].propertyname]],
          dataLabels: {
            format: '<div style="text-align:center; margin-top: -55px; font-family: \'Open Sans\'"><span style="font-size:25px;color:' +
                  ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y:,.0f}%</span><br/>' +
                  '<span style="font-size:12px;font-weight: normal"> ' + i18n.t('chartsData.recovery') + ' </span>' +
                  '<br>' +
                  '<span style="color: #666666;cursor: default;font-size: 15px;font-weight: 800;fill: #666666;l">' + separadorMiles(Math.round(values[0][dataserie.calculatedseries[1].propertyname])) + i18n.t(dataserie.name) + '</span>' +
                  '<br><span style="color: #666666;cursor: default;font-size: 14px;font-weight: 800;fill: #666666;l">(' + (Math.round(values[0][dataserie.calculatedseries[2].propertyname]) > 0 ? separadorMiles(values[0][dataserie.calculatedseries[2].propertyname]) : '-') + i18n.t('marketplace.units') + ')' + '</span>' +
                  '</div>'
          },
          tooltip: {
            valueSuffix: '€/sqm'
          }
        })
      } else if (chartinfo.charttype === 'solidgaugeclean') {
        chart.title = { text: i18n.t(chartinfo.charttitle) }
        chart.yAxis.labels.formatter = function() {
          var data = {
            min: values[0][dataserie.calculatedseries[2].propertyname],
            max: values[0][dataserie.calculatedseries[3].propertyname]
          }
          if (this.isFirst) return `${separadorMiles(Math.round(data.min))} ${i18n.t(dataserie.name)}`
          else return `${separadorMiles(Math.round(data.max))} ${i18n.t(dataserie.name)}`
        }
        chart.series.push({
          name: i18n.t('chartsData.recovery'),
          data: [values[0][dataserie.calculatedseries[0].propertyname]],
          dataLabels: {
            format: '<div style="text-align:center; margin-top: -55px; font-family: \'Open Sans\'"><span style="font-size:25px;color:' +
                  ((Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black') + '">{y:,.0f}%</span>' +
                  '<br>' +
                  '<span style="font-size:12px;font-weight: normal"> ' + i18n.t('chartsData.individual') + ' </span>' +
                  '<br><span style="color: #666666;cursor: default;font-size: 14px;font-weight: 800;fill: #666666;l">(' + (Math.round(values[0][dataserie.calculatedseries[1].propertyname]) > 0 ? separadorMiles(values[0][dataserie.calculatedseries[1].propertyname]) : '-') + i18n.t('marketplace.units') + ')' + '</span>' +
                  '</div>'
          },
          tooltip: {
            valueSuffix: '€/sqm'
          }
        })
      } else if (chartinfo.charttype === 'area') {
        chart.series.push({
          name: i18n.t('chartsData.supply'),
          data: values,
          color: '#28cf64 ',
          fillColor: {
            pattern: {
              color: '#28cf64 '
            }
          },
          marker: {
            radius: 0
          }
        })
      } else if (chartinfo.charttype === 'supplydist') {
        alllabels = values[0].supplylocalvscountry.map((item) => {
          return item.label
        })
        const datacountry = values[0].supplycountry.map((item) => { return -1 * Math.round(item.em2) })
        const datalocal = values[0].supplylocalvscountry.map((item) => { return Math.round(item.em2) })
        chart.series.push({
          name: i18n.t('maps.country'),
          data: datacountry,
          tooltip: {
            valueSuffix: ' %'
          },
          marker: {
            enabled: false
          },
          color: '#505050'
        })
        chart.series.push({
          name: locationname,
          data: datalocal,
          tooltip: {
            valueSuffix: ' %'
          },
          marker: {
            enabled: false
          },
          color: '#28cf64 '
        })
      } else if (chartinfo.charttype === 'benchmark') {
        chart = build_basicbar(dataserie.name, dataserie.zIndex, dataserie.calculatedseries[0].propertyname, values[0], country_name, locationname, dataserie.type, geolevelselected)
      } else {
        chart.series.push({
          yAxis: dataserie.yAxis,
          zIndex: dataserie.zIndex,
          name: i18n.t(dataserie.name),
          data: values,
          type: dataserie.type,
          marker: {
            enabled: values.length === 1
          },
          color: dataserie.color,
          tooltip: dataserie.tooltip
        })
      }
    }
  })
  if (chartinfo.charttype === 'series' || chartinfo.charttype === 'stackcolumnrooms') {
    alllabels = allQuarters(alllabels.map((item) => { return item.name }))
  }
  if (alllabels.length > 0) {
    chart.xAxis = {
      type: 'category',
      categories: alllabels
    }
  }
  // debugger
  return chart
}

function allQuarters(quarters, minYear = 1) {
  const maxYear = 30
  const all = []
  for (let i = minYear; i <= maxYear; i++) {
    for (let j = 1; j < 5; j++) {
      var year = i < 10 ? '0' + i : i
      all.push(`Q${j} ${year}`)
    }
  }

  return all
}

async function printTableBrowser(idContainerPrint) {
  var element = document.getElementById(idContainerPrint)

  html2canvas(element, { useCORS: false, foreignObjectRendering: false, fontFamily: 'Montserrat-Regular' }).then(function(canvas) {
    const screenshot = canvas.toDataURL()
    const div = document.createElement('div')
    div.id = 'container-img-canvas-temporal-id'
    const img = document.createElement('img')
    img.src = screenshot
    img.id = 'img-canvas-temporal-id'
    div.appendChild(img)
    document.body.appendChild(div)
    return img
  })
    .then(canvas => {
      var a = window.open('', '', 'height=800, width=800')
      a.document.write('<html>')
      a.document.write('<body>')
      a.document.write(document.getElementById('container-img-canvas-temporal-id').innerHTML)
      a.document.write('</body></html>')
      a.document.close()
      a.print()

      var imgDom = document.getElementById('container-img-canvas-temporal-id')
      imgDom.parentNode.removeChild(imgDom)
    })
}

/**
 * Imprimir una tabla de charts a PDF directamente
 * @param {*} idContainerPrint
 * @param {*} fileName
 */
async function printTablePDF(idContainerPrint, fileName, direction) {
  var element = document.getElementById(idContainerPrint)
  element.click()

  var p_prime = element.cloneNode(true)
  p_prime.id = 'temporal-table-clone'
  p_prime.classList.remove('el-col-12')
  p_prime.classList.add('el-col-24')

  if (direction === 'portrait') {
    p_prime.classList.add('printing-table-pdf')
    p_prime.classList.remove('container-table-responsive')
    p_prime.classList.remove('container-table-responsive--first')
    p_prime.classList.remove('table-container-two-row--salestock-1')
    p_prime.classList.remove('first-table-supply')
    p_prime.style.paddingTop = '0 !important'
    p_prime.style.marginTop = '0 !important'
  } else if (direction === 'landscape') {
    p_prime.classList.add('printing-table-pdf--2')
  } else {
    p_prime.classList.add('printing-table-pdf--3')
    p_prime.classList.remove('first-table-supply')
  }

  p_prime.removeChild(p_prime.getElementsByClassName('container-download-table')[0])
  var selectorNode = p_prime.getElementsByClassName('chart-div-selector-wrapper')
  if (selectorNode !== undefined && selectorNode !== null && selectorNode.length >= 1) {
    p_prime.removeChild(selectorNode[0])
  }

  document.body.appendChild(p_prime)

  var finalTable = document.getElementById('temporal-table-clone')

  var opt = {
    margin: [10, 20, 0, 10],
    filename: 'brains-report.pdf',
    image: { type: 'jpeg', quality: 1 },
    html2canvas: { scale: 2 },
    pagebreak: { mode: 'avoid-all' },
    jsPDF: {
      unit: 'px',
      format: [1110, 800],
      // format: [1880, 1060],
      // format: [1400, 800],
      // orientation: 'portrait',
      // orientation: direction
      orientation: 'landscape'
    }
  }

  html2pdf()
    .set(opt)
    .from(finalTable)
    .toPdf()
    .save()
    .then(() => {
      var clonedNode = document.getElementById('temporal-table-clone') // eslint-disable-line no-mixed-spaces-and-tabs
      clonedNode.parentNode.removeChild(clonedNode) // eslint-disable-line no-mixed-spaces-and-tabs
    })
  return
}

/**
 *
 * @param {*} idContainerPrint el id del contenedor que contiene la tabla que vamos a imprimir
 * @param {*} typePrint png o jpeg Cualquier otro devuelve un false
 * @param {*} chartName el nombre que tendrá el chart al descargarlo
 */
async function printTable(idContainerPrint, typePrint, chartName) {
  if (typePrint !== 'jpeg' && typePrint !== 'png') return
  if (chartName === '' || chartName === null || chartName === undefined) {
    chartName = 'my-chart'
  }

  var chart = document.getElementById(idContainerPrint)
  var oldBorder = chart.style.border

  // Se añade el logo al chart
  var img = document.createElement('img')
  img.src = '/images/logo-escalado-charts.png'
  img.classList.add('print-chart-logo-brains')
  chart.appendChild(img)

  // Se elimina el borde y el selector antes de imprimir, luego se vuelve a añadir
  chart.style.border = 'none'
  // var selectContainer = document.getElementsByClassName('chart-div-selector-wrapper')

  // if (selectContainer !== null && selectContainer !== undefined) {
  //   var oldDisplaySelect = selectContainer[0].style.display
  //   selectContainer[0].style.display = 'none'
  // }

  // Se imprime el chart
  await makeScreenshot(idContainerPrint, typePrint, chartName)

  // Se añaden los valores antiguos
  chart.style.border = oldBorder
  chart.removeChild(img)
  // if (selectContainer !== null && selectContainer !== undefined) {
  //   selectContainer[0].style.display = oldDisplaySelect
  // }
}

/**
 *
 * @param {*} idContainerPrint id del contenedor a imprimir
 * @param {*} typePrint el tipo de archivo a imprimir, siempre tiene que ser png o jpeg
 * @param {*} fileName el nombre del archivo resultante
 * @returns
 */
async function makeScreenshot(idContainerPrint, typePrint, fileName) {
  return new Promise((resolve, reject) => {
    const node = document.getElementById(idContainerPrint)

    html2canvas(node, { useCORS: false, foreignObjectRendering: false, fontFamily: 'Montserrat-Regular' }).then(function(canvas) {
      document.body.appendChild(canvas)
      canvas.style.display = 'none'
      return canvas
    })
      .then(canvas => {
        const image = canvas.toDataURL('image/' + typePrint).replace('image/' + typePrint, 'image/octet-stream')
        const a = document.createElement('a')
        a.setAttribute('download', fileName + '.' + typePrint)
        a.setAttribute('href', image)
        a.click()
        canvas.remove()
        resolve(true)
      })
  })
}

/**
 *
 * @param {*} idContainerPrint id del contenedor a realizar la foto
 * @returns formato de foto para añadir directamente al html
 */
async function getScreenshotImg(idContainerPrint) {
  return new Promise((resolve, reject) => {
    const node = document.getElementById(idContainerPrint)

    html2canvas(node, { useCORS: false, foreignObjectRendering: false, fontFamily: 'Montserrat-Regular' }).then(function(canvas) {
      return canvas
    })
      .then(canvas => {
        const image = canvas.toDataURL('image/jpeg').replace('image/jpeg', 'image/octet-stream')
        resolve(image)
      })
  })
}

var SERIESDATA
var SERIESDATA_RENTNET
var constructor_basicbar = function(title, unit, chartname, selectorhtml, country_name, geo_name, chartType = '', geolevel = null) {
  var scrollbar_template = {
    enabled: true,
    barBackgroundColor: '#1e3cff',
    trackBackgroundColor: 'lightgrey',
    barBorderRadius: 0,
    barBorderWidth: 0,
    buttonBackgroundColor: 'white',
    buttonBorderWidth: 0,
    buttonArrowColor: 'white',
    buttonBorderRadius: 0,
    trackBorderWidth: 0,
    trackBorderColor: 'silver',
    trackBorderRadius: 0,
    minWidth: 4,
    margin: 5,
    height: 8,
    step: 10
  }

  return {
    chart: {
      height: 630,
      type: 'bar',
      events: {
        load: function() {
          var chart = this
          chart.update({
            chart: {
              spacingLeft: 40
            }
          }, true, false, false)
          if (selectorhtml !== '') {
            // var domele = document.querySelectorAll('.' + chartname + '_chart .highcharts-container')
            var domele = [document.getElementById(chart.container.id)]
            if (domele === null || domele === undefined || domele.length < 1) { return }
            domele = domele[0]
            domele.insertAdjacentHTML('beforebegin', selectorhtml)
            setTimeout(function() {
              var old_element = document.getElementById(chartname + '_selector')
              var new_element = old_element.cloneNode(true)
              old_element.parentNode.replaceChild(new_element, old_element)
              document.getElementById(chartname + '_selector').addEventListener('change', function() {
                var varvalue = this.value

                var sorteddata = []
                if (chartname === 'timetosaletop25') {
                  sorteddata = getParsedData(varvalue, false, country_name, geo_name, chartType, geolevel)
                } else {
                  // Se comprueba si estamos seleccionado el chart de Transactions Figures con el filtro de Todas las transacciones
                  if (chartname === 'top25transactionsfigures' && varvalue === 'number_Transactions') {
                    sorteddata = getParsedData(varvalue, true, country_name, geo_name, chartType, geolevel, true)
                  } else {
                    sorteddata = getParsedData(varvalue, true, country_name, geo_name, chartType, geolevel)
                  }
                }
                var updunit = getTitleUnit(varvalue)[1]
                chart.update({
                  yAxis: [{
                    labels: {
                      formatter: function() { return this.value.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + (this.value === 0 ? ' ' + updunit : '') }
                    }
                  }],
                  xAxis: {
                    min: sorteddata.length <= 26 ? null : 0,
                    max: sorteddata.length <= 26 ? null : 25,
                    scrollbar: sorteddata.length <= 26 ? null : scrollbar_template
                  },
                  tooltip: {
                    formatter: function() {
                      var color = '#6b6a6a'
                      if (this.point.color === '#28cf64 ') {
                        color = '#28cf64 '
                      }
                      return `<span style="font-size:11px">${separadorMiles(this.point.y.toFixed(2).replace('.', ',').replace(',00', ''))}  ${updunit}</span><br> <span style="color:${color}">${this.point.name}</span><br />`
                    }
                  }
                })

                chart.series[0].setData(sorteddata)
              })
            }, 1000)
          }
        }
      }
    },
    title: {
      text: title
    },
    xAxis: {
      type: 'category',
      scrollbar: scrollbar_template,
      min: 0,
      max: 25
    },
    yAxis: [
      {
        labels: {
          formatter: function() { return this.value.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + (this.value === 0 ? ' ' + unit : '') }
        },
        title: {
          text: ''
        },
        startOnTick: false,
        maxPadding: 0,
        style: {
          fontFamily: 'Open Sans'
        }
      }
    ],
    legend: {
      enabled: false
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        grouping: false,
        borderWidth: 0,
        groupPadding: 0.1,
        animation: true,
        cropThreshold: 10001,
        getExtremesFromAll: true
      }
    },
    tooltip: {
      formatter: function() {
        var color = '#6b6a6a'
        if (this.point.color === '#28cf64 ') {
          color = '#28cf64 '
        }

        var value_tooltip = separadorMiles(this.point.y.toFixed(2).replace('.', ',').replace(',00', ''))

        // Se gestiona que se eliminen los decimales para los precios que sean superiores a 1000
        if (unit === i18n.t('marketplace.eur-sqm') && this.point.y > 1000) {
          value_tooltip = separadorMiles(Math.round(this.point.y))
        }

        return `<span style="font-size:11px">${value_tooltip}  ${unit}</span><br> <span style="color:${color}">${this.point.name}</span><br />`
      }
    },
    series: [],
    credits: {
      enabled: false
    }
  }
}
function build_basicbar(chartname, type = null, defaultvar, alldata, country_name, geo_name, chartType = '', geolevel = null) {
  if (chartname === 'rentNetBench' || chartname === 'rentNetBenchEsqm' || chartname === 'rentNetYieldBench') {
    SERIESDATA_RENTNET = alldata
  } else {
    SERIESDATA = alldata
  }

  var selectorval = document.getElementById(chartname + '_selector')
  var selectorhtml = type !== null ? getSelectorOptions(type, chartname, geolevel) : ''
  if (selectorval !== undefined && selectorval !== null) { selectorval = selectorval.value } else { selectorval = defaultvar }
  var [title, unit] = getTitleUnit(selectorval)
  var chart_obj = constructor_basicbar(title, unit, chartname, selectorhtml, country_name, geo_name, chartType, geolevel)

  var sorteddata = []
  if (chartname === 'timetosaletop25') {
    sorteddata = getParsedData(selectorval, false, country_name, geo_name, chartType, geolevel, false)
  } else {
    sorteddata = getParsedData(selectorval, true, country_name, geo_name, chartType, geolevel, false)
  }

  var allseries = []
  // Mayor que 1 porque si solo hay un resultado, no se muestra el gráfico
  if (sorteddata.length > 1) {
    allseries.push({
      name: 'data_bar',
      stack: 'bar',
      data: sorteddata,
      marker: {
        enabled: false
      }
    })
  }

  // Gestionamos el número máximo de elementos dentro del chart (si es menos de 25, fijamos ese numero como como tope)
  if (sorteddata.length <= 26) {
    chart_obj.xAxis.min = null
    chart_obj.xAxis.max = null
    chart_obj.xAxis.scrollbar = null
    // chart_obj.xAxis.tickLength = 0
    // chart_obj.xAxis.max = sorteddata.length - 1
  }

  // Mayor que 1 porque si solo hay un resultado, no se muestra el gráfico
  if (allseries.length > 1 && allseries[0].data.length < 20) { chart_obj.xAxis = { type: 'category' } }
  chart_obj.series = allseries

  return chart_obj
}

// #region Tools
// En caso de que el chart necesite selector para elegir entre distintos datos (ej.: € o ' + i18n.t("marketplace.eur-sqm") + ')
function getParsedData(sortby, desc, country_name, geo_name, chartType, geolevel, country_label_hidden = false) {
  var sorteddata = []
  if (checkSortByNetRent(sortby)) {
    sorteddata = _.sortBy(SERIESDATA_RENTNET, sortby)
  } else {
    sorteddata = _.sortBy(SERIESDATA, sortby)
  }

  // Comprobamos si llegan estos datos vacios
  if (sortby === 'number_Transactions' || sortby === 'number_Transactions_Over1k' || sortby === 'transactions_Vs_BuildStock') {
    sorteddata = sorteddata.filter(item => item[sortby] !== null && item[sortby] !== 0)
  } else {
    sorteddata = sorteddata.filter(item => item[sortby] !== null)
  }
  if (desc) { sorteddata = sorteddata.reverse() }
  if (country_label_hidden) { sorteddata = sorteddata.filter((item) => { return item['label'] !== country_name }) }
  sorteddata = _.first(sorteddata, 1000)
  sorteddata = _.map(sorteddata, function(item) {
    const name = getChartTypeName(chartType, item, geolevel)

    return {
      // 'name': item['label'],
      'name': name,
      'y': item[sortby] > 1000 ? Math.round(item[sortby]) : item[sortby],
      'color': item['label'] === country_name ? '#a3a3a3' : (item['label'] === geo_name ? '#28cf64 ' : '#1e3cff')
    }
  })
  sorteddata = _.filter(sorteddata, function(item) { return item.y !== null })
  return sorteddata
}

/**
 * Función para determinar el nombre de un label de chart en caso de que se le añada algún fragmento de texto extra
 * Como es el caso para los quarters de algunos graficos de asking y transactions
 * @param {*} chartType
 * @param {*} name
 */
function getChartTypeName(chartType, item, geolevel) {
  let name = item['label']
  if (name === undefined) {
    name = item['name']
    return name
  }
  if (geolevel !== null && geolevel.level === 0) {
    switch (chartType) {
      case 'asking':
        if (item.qQ_Asking_Data !== null) {
          name += ' (' + item.qQ_Asking_Data + ')'
        }
        break
      case 'transactions':
        if (item.qQ_Transactions_Data !== null) {
          name += ' (' + item.qQ_Transactions_Data + ')'
        }
        break
    }
  }
  return name
}

function getSelectorOptions(type, chartname, geolevel) {
  var htmlselector = '<div class="chart-div-selector-wrapper">'
  htmlselector += '<select id="' + chartname + '_selector" class="chart-div-selector">'
  switch (type) {
    case 1:
      htmlselector += '<option selected value="em2_Asking">' + i18n.t('marketplace.eur-sqm') + '</option>'
      htmlselector += '<option value="em2_Asking_ND">' + i18n.t('marketplace.eur-sqm') + ' ND</option>'
      htmlselector += '<option value="em2_Asking_2H">' + i18n.t('marketplace.eur-sqm') + ' 2H</option>'
      htmlselector += '<option value="em2_Price">' + i18n.t('price') + '</option>'
      htmlselector += '<option value="em2_Price_ND">' + i18n.t('price') + ' ND</option>'
      htmlselector += '<option value="em2_Price_2H">' + i18n.t('price') + ' 2H</option>'
      break
    case 2:
      htmlselector += '<option selected value="avg_Time_To_Sale">' + i18n.t('dataSelectors.all') + '</option>'
      htmlselector += '<option value="ttS_ND">' + i18n.t('dataSelectors.new-developments') + '</option>'
      htmlselector += '<option value="ttS_2H">' + i18n.t('chartsData.2nd-hand') + '</option>'
      break
    case 3:
      // if (geolevel !== null && geolevel.level === 0) {
      htmlselector += '<option selected value="number_Transactions_Over1k">' + i18n.t('chartsData.over-1k-inhab') + '</option>'
      htmlselector += '<option value="number_Transactions">' + i18n.t('chartsData.total-vol') + '</option>'
      // }
      break
    case 4:
      htmlselector += '<option selected value="asking_Growth_Var_YoY_Em2">' + i18n.t('marketplace.eur-sqm') + ' YoY</option>'
      htmlselector += '<option value="asking_Growth_Var_QoQ_Em2">' + i18n.t('marketplace.eur-sqm') + ' QoQ</option>'
      htmlselector += '<option value="asking_Growth_Var_YoY_Em2_ND">' + i18n.t('marketplace.eur-sqm') + ' ND YoY</option>'
      htmlselector += '<option value="asking_Growth_Var_QoQ_Em2_ND">' + i18n.t('marketplace.eur-sqm') + ' ND QoQ</option>'
      htmlselector += '<option value="asking_Growth_Var_YoY_Em2_2H">' + i18n.t('marketplace.eur-sqm') + ' 2H YoY</option>'
      htmlselector += '<option value="asking_Growth_Var_QoQ_Em2_2H">' + i18n.t('marketplace.eur-sqm') + ' 2H QoQ</option>'
      break
    case 5:
      htmlselector += '<option selected value="transactions_Var_YoY_Em2">YoY</option>'
      htmlselector += '<option value="transaction_Var_QoQ_Em2">QoQ</option>'
      break
    case 6:
      htmlselector += '<option selected value="em2_month_asking_rent">' + i18n.t('marketplace.eur-sqm') + '</option>'
      htmlselector += '<option value="price_month_asking_rent">' + i18n.t('price') + '</option>'
      break
    case 7:
      htmlselector += '<option selected value="asking_rent_var_YoY_Em2_month">YoY</option>'
      htmlselector += '<option value="asking_rent_var_QoQ_Em2_month">QoQ</option>'
      break
    case 8:
      htmlselector += '<option selected value="gross_Yield_Asking">' + i18n.t('asking') + '</option>'
      htmlselector += '<option value="gross_Yield_Transactions">' + i18n.t('dataSelectors.transactions') + '</option>'
      break
    case 9:
      htmlselector += '<option selected value="rent_Vs_Sale">' + i18n.t('dataSelectors.all') + '</option>'
      htmlselector += '<option value="rent_Vs_Sale_ND">ND</option>'
      htmlselector += '<option value="rent_Vs_Sale_2H">2H</option>'
      break
    case 10:
      htmlselector += '<option selected value="asking_Growth_Var_YoY_Em2">YoY</option>'
      htmlselector += '<option value="asking_Growth_Var_QoQ_Em2">QoQ</option>'
      break
    case 11:
      htmlselector += '<option value="net_rent_flat_room1">1 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option value="net_rent_flat_room2">2 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option selected value="net_rent_flat_room3">3 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option value="net_rent_flat_room4">4 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option value="net_rent_house_room1">1 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      htmlselector += '<option value="net_rent_house_room2">2 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      htmlselector += '<option value="net_rent_house_room3">3 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      htmlselector += '<option value="net_rent_house_room4">4 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      break
    case 12:
      htmlselector += '<option value="net_em2_flat_room1">1 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option value="net_em2_flat_room2">2 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option selected value="net_em2_flat_room3">3 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option value="net_em2_flat_room4">4 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option value="net_em2_house_room1">1 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      htmlselector += '<option value="net_em2_house_room2">2 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      htmlselector += '<option value="net_em2_house_room3">3 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      htmlselector += '<option value="net_em2_house_room4">4 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      break
    case 13:
      htmlselector += '<option value="net_yield_flat_room1">1 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option value="net_yield_flat_room2">2 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option selected value="net_yield_flat_room3">3 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option value="net_yield_flat_room4">4 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.flat') + '</option>'
      htmlselector += '<option value="net_yield_house_room1">1 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      htmlselector += '<option value="net_yield_house_room2">2 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      htmlselector += '<option value="net_yield_house_room3">3 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      htmlselector += '<option value="net_yield_house_room4">4 ' + i18n.t('maps.room') + ' ' + i18n.t('dataSelectors.house') + '</option>'
      break
    default:
      htmlselector += '<option selected value="0">Debug - err1</option>'
      // Añadir opción nueva si sale por aqui
      break
  }

  htmlselector += '</select>'
  htmlselector += '</div>'
  return htmlselector
}

function checkSortByNetRent(sortby) {
  switch (sortby) {
    case 'net_rent_flat_room1':
    case 'net_rent_flat_room2':
    case 'net_rent_flat_room3':
    case 'net_rent_flat_room4':
    case 'net_rent_house_room1':
    case 'net_rent_house_room2':
    case 'net_rent_house_room3':
    case 'net_rent_house_room4':
    case 'net_em2_flat_room1':
    case 'net_em2_flat_room2':
    case 'net_em2_flat_room3':
    case 'net_em2_flat_room4':
    case 'net_em2_house_room1':
    case 'net_em2_house_room2':
    case 'net_em2_house_room3':
    case 'net_em2_house_room4':
    case 'net_yield_flat_room1':
    case 'net_yield_flat_room2':
    case 'net_yield_flat_room3':
    case 'net_yield_flat_room4':
    case 'net_yield_house_room1':
    case 'net_yield_house_room2':
    case 'net_yield_house_room3':
    case 'net_yield_house_room4':
      return true
    default:
      return false
  }
}

function getTitleUnit(name) {
  switch (name) {
    case 'em2_Asking':
    case 'em2_Asking_ND':
    case 'em2_Asking_2H':
      return [i18n.t('assetData.asking-prices'), i18n.t('marketplace.eur-sqm')]
    case 'em2_Price':
    case 'em2_Price_ND':
    case 'em2_Price_2H':
      return [i18n.t('assetData.asking-prices'), '€']
    case 'em2_Transaction':
      return [i18n.t('assetData.transactions-prices'), i18n.t('marketplace.eur-sqm')]
    case 'avg_Time_To_Sale':
    case 'ttS_ND':
    case 'ttS_2H':
      return [i18n.t('dataSelectors.published-time'), i18n.t('assetData.months')]
    case 'number_Transactions_Over1k':
      return [i18n.t('chartsData.trans-figures'), i18n.t('chartsData.uts-over-1k-hab')]
    case 'number_Transactions':
      return [i18n.t('chartsData.trans-figures'), i18n.t('uts')]
    case 'market_Recovery':
      return [i18n.t('chartsData.market-recovery-trans-prices'), '%']
    case 'market_Recovery_Units':
      return [i18n.t('chartsData.market-recovery-units'), '%']
    case 'asking_Growth_Var_YoY_Em2':
    case 'asking_Growth_Var_QoQ_Em2':
    case 'asking_Growth_Var_YoY_Em2_ND':
    case 'asking_Growth_Var_QoQ_Em2_ND':
    case 'asking_Growth_Var_YoY_Em2_2H':
    case 'asking_Growth_Var_QoQ_Em2_2H':
      return [i18n.t('chartsData.asking-prices-growth'), '%']
    case 'transactions_Var_YoY_Em2':
    case 'transaction_Var_QoQ_Em2':
      return [i18n.t('chartsData.trans-prices-growth'), '%']
    case 'transactions_Vs_BuildStock':
      return [i18n.t('chartsData.trans-vs-built-last-year'), '%']
    case 'asking_Recovery_Sale':
      return [i18n.t('chartsData.asking-recovery-new-vs-old'), '%']

    case 'em2_month_asking_rent':
      return [i18n.t('chartsData.asking-prices-rent'), i18n.t('marketplace.eur-sqm')]
    case 'price_month_asking_rent':
      return [i18n.t('chartsData.asking-prices-rent'), '€']
    case 'avg_Time_To_Rent':
      return [i18n.t('chartsData.published-time-rent'), i18n.t('assetData.months')]
    case 'asking_rent_var_YoY_Em2_month':
    case 'asking_rent_var_QoQ_Em2_month':
      return [i18n.t('chartsData.asking-prices-growth-rent'), '%']
    case 'gross_Yield_Asking':
    case 'gross_Yield_Transactions':
      return [i18n.t('dataSelectors.gross-yield'), '%']
    case 'asking_Recovery_Rent':
      return [i18n.t('chartsData.asking-recovery-new-vs-old-rent'), '%']

    case 'rent_Vs_Sale':
    case 'rent_Vs_Sale_ND':
    case 'rent_Vs_Sale_2H':
      return [i18n.t('chartsData.rent-vs-sale'), '%']
    case 'particular_Vs_Broker_Sale':
      return [i18n.t('chartsData.privates-vs-brokers-sale'), '%']
    case 'particular_Vs_Broker_Rent':
      return [i18n.t('chartsData.privates-vs-brokers-rent'), '%']

    case 'net_rent_flat_room1':
    case 'net_rent_flat_room2':
    case 'net_rent_flat_room3':
    case 'net_rent_flat_room4':
    case 'net_rent_house_room1':
    case 'net_rent_house_room2':
    case 'net_rent_house_room3':
    case 'net_rent_house_room4':
      return [i18n.t('assetData.asking-prices') + ' (' + i18n.t('net-rent') + ' €)', '€']

    case 'net_em2_flat_room1':
    case 'net_em2_flat_room2':
    case 'net_em2_flat_room3':
    case 'net_em2_flat_room4':
    case 'net_em2_house_room1':
    case 'net_em2_house_room2':
    case 'net_em2_house_room3':
    case 'net_em2_house_room4':
      return [i18n.t('assetData.asking-prices') + ' (' + i18n.t('net-rent') + ' ' + i18n.t('marketplace.eur-sqm') + ')', i18n.t('marketplace.eur-sqm')]

    case 'net_yield_flat_room1':
    case 'net_yield_flat_room2':
    case 'net_yield_flat_room3':
    case 'net_yield_flat_room4':
    case 'net_yield_house_room1':
    case 'net_yield_house_room2':
    case 'net_yield_house_room3':
    case 'net_yield_house_room4':
      return [i18n.t('net-yield') + ' (' + i18n.t('net-rent') + ')', '%']
    case 'em2':
      return [i18n.t('top-brokers-sqm'), 'e\|sqm']
    case 'units':
      return [i18n.t('top-brokers-units'), 'units']

    default:
    {
      // debugger
      // return [i18n.t(name), '%']
      return ['debug - add case in charts_builder.js -> getTitleUnit()', 'define units']
    }
  // Añadir opción nueva si sale por aquí
  }
}

function filterOutliers(someArray) {
  // Copy the values, rather than operating on references to existing values
  var values = someArray.concat()

  // Then sort
  values.sort(function(a, b) {
    return a - b
  })

  /* Then find a generous IQR. This is generous because if (values.length / 4)
   * is not an int, then really you should average the two elements on either
   * side to find q1.
   */
  var q1 = values[Math.floor((values.length / 4))]
  // Likewise for q3.
  var q3 = values[Math.ceil((values.length * (3 / 4)))]
  var iqr = q3 - q1

  // Then find min and max values
  var maxValue = q3 + iqr * 1.5
  var minValue = q1 - iqr * 1.5

  // Then filter anything beyond or beneath these values.
  var filteredValues = values.filter(function(x) {
    return (x <= maxValue) && (x >= minValue)
  })

  // Then return
  return filteredValues
}

function zerosFormatter(labelValue) {
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e+9

    ? Math.abs(Number(labelValue)) / 1.0e+9 + 'B'
    // Six Zeroes for Millions
    : Math.abs(Number(labelValue)) >= 1.0e+6

      ? Math.abs(Number(labelValue)) / 1.0e+6 + 'M'
      // Three Zeroes for Thousands
      : Math.abs(Number(labelValue)) >= 1.0e+3

        ? Math.abs(Number(labelValue)) / 1.0e+3 + 'K'

        : Math.abs(Number(labelValue))
}

// #endregion

export {
  generateHigchartOptions,
  generateStackTableOptions,
  printTable,
  printTablePDF,
  printTableBrowser,
  getScreenshotImg,
  separadorMiles,
  build_basicbar,
  allQuarters,
  filterOutliers,
  zerosFormatter
}
